import { computed, ref } from 'vue'

/** Shared light/dark choice for the landing page and the rest of the app. */
const STORAGE_KEY = 'lms.landing-theme'

export type LandingTheme = 'dark' | 'light'

function readStored(): LandingTheme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

const theme = ref<LandingTheme>(typeof localStorage === 'undefined' ? 'light' : readStored())

function apply(next: LandingTheme) {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  root.dataset.landingTheme = next
  root.classList.toggle('landing-light', next === 'light')
  root.classList.toggle('dark', next === 'dark')
  root.style.colorScheme = next
}

apply(theme.value)

export function useLandingTheme() {
  const isLight = computed(() => theme.value === 'light')

  function setTheme(next: LandingTheme) {
    theme.value = next
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      // Private mode.
    }
    apply(next)
  }

  function toggle() {
    setTheme(theme.value === 'dark' ? 'light' : 'dark')
  }

  return { theme, isLight, setTheme, toggle }
}
